import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'searchfilter',
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], searchText: string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = this.formatText(searchText);

    return items.filter((item) =>
      Object.entries(item).find((temp: any) =>
        this.formatText(String(temp[1])).includes(searchText)
      )
    );
  }
  formatText(text) {
    const parsed = text
      .toString()
      .normalize('NFD')
      .replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, '');
    return parsed.toLowerCase();
  }
}
